module.exports = __webpack_public_path__ + "static/media/napa-valley-logo-new@3x.96bec7bf.png";